import { Common } from '~/models/common';
import { Documents } from '~/models/documents';

export const documentsService = {
	fetch: async (): Promise<Documents.Model[]> => {
		const params = {
			filter: {
				status: Common.Status.PUBLISHED,
			},
			fields: ['*', 'preview.*', 'file.*'],
		};

		try {
			const response = await $fetch<Documents.Model[]>(Documents.api, {
				method: 'POST',
				body: { params },
			});

			return response;
		} catch (error) {
			console.error('Failed to fetch Documents:', error);

			return [];
		}
	},
};
